// 은행코드 불러오기
export const bank = [
  {name: '산업은행', idx: 1},
  {name: '기업은행', idx: 2},
  {name: '국민은행', idx: 3},
  {name: '외환은행', idx: 4},
  {name: '수협', idx: 5},
  {name: '농협', idx: 6},
  {name: '우리은행', idx: 7},
  {name: '제일은행', idx: 8},
  {name: '시티은행', idx: 9},
  {name: '대구은행', idx: 10},
  {name: '부산은행', idx: 11},
  {name: '광주은행', idx: 12},
  {name: '제주은행', idx: 13},
  {name: '전북은행', idx: 14},
  {name: '경남은행', idx: 15},
  {name: '새마을금고', idx: 16},
  {name: '신협', idx: 17},
  {name: '우체국은행', idx: 18},
  {name: '하나은행', idx: 19},
  {name: '신한은행', idx: 20},
  {name: '카카오뱅크', idx: 21},
  {name: '케이뱅크', idx: 22},
  {name: '토스뱅크', idx: 23},
  {name: '한국은행', idx: 24},
  {name: '한국수출입은행', idx: 25},
  {name: '지역농∙축협', idx: 26},
  {name: '저축은행', idx: 27},
  {name: '금융결제원', idx: 28},
  {name: 'KB증권', idx: 29}
]

export function bankNameChange(value) {
  let name = ''
  for(var i = 0; bank.length > i; i++) {
    if(Number(value) === bank[i].idx) {
      name = bank[i].name
    }
  }

  return name
}